import React from "react";
import { Tag } from "primereact/tag";
import { classNames } from "primereact/utils";
import styles from "./StatusPill.module.scss";
import { StatusType, StatusVariant } from "./StatusPill.types";

// Import the status configurations, modify as needed for new implementations
import { STATUS_CONFIGS } from "./StatusPill.constants";

const capitalize = (str: string): string => {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export interface StatusPillProps {
  status: string;
  statusType: StatusType;
  isSelected?: boolean;
  variant?: StatusVariant;
  className?: string;
  displayText?: string;
}

export const StatusPill: React.FC<StatusPillProps> = ({
  status,
  statusType,
  isSelected = false,
  variant = "outlined",
  className = "",
  displayText,
}) => {
  // Get the status configuration
  const statusConfig = STATUS_CONFIGS[statusType] || {};
  const config = statusConfig[status] || {};
  // Use backgroundColor if available (for filled pills), otherwise use color
  const colorName = (variant === "filled" && config.backgroundColor) || config.color || "gray";

  // Format the status text
  const formatStatus = (status: string): string => {
    return capitalize(status.replace(/([A-Z])/g, " $1").trim());
  };

  const text = displayText || (status ? formatStatus(status) : "");

  // Combine all classes using CSS modules
  const pillClasses = classNames(
    styles.pill,
    {
      [styles["pill-selected"]]: isSelected,
      [styles[`pill-${colorName}`]]: true,
      [styles.outlined]: variant === "outlined" && !isSelected,
      [styles.filled]:
        (variant === "filled" && !isSelected) ||
        (statusType === "user" && (status === "admin" || status === "learner")),
    },
    className
  );

  return <Tag className={pillClasses} value={text} />;
};
